import { useState } from 'react';

// Helper function to format for Advyzon
const formatForAdvyzon = (portfolio) => {
    let rows = [['Ticker', 'Target']];
    portfolio.forEach(item => {
        let formattedWeight = (item.wgt * 100).toFixed(2) || 0;
        rows.push([item.symbol, formattedWeight]);
    });
    return rows;
};

// Helper function to format for Fidelity
const formatForFidelity = (portfolio) => {
    let rows = [['Symbol', 'Weight']];
    portfolio.forEach(item => {
        let formattedWeight = item.wgt || 0;
        rows.push([item.symbol, formattedWeight]);
    });
    return rows;
};

// Helper function for the default format
const formatForDefault = (portfolio) => {
    let rows = [['Symbol', 'Weight (%)']];
    portfolio.forEach(item => {
        let formattedWeight = (item.wgt * 100).toFixed(2) || 0;
        rows.push([item.symbol, formattedWeight]);
    });
    return rows;
};

// Main hook
export const usePortfolioExports = () => {
    const [csvData, setCsvData] = useState([]);

    // Function to handle formatting for each provider
    const downloadToAdvyzon = (portfolio) => {
        setCsvData(formatForAdvyzon(portfolio));
    };

    const downloadToFidelity = (portfolio) => {
        setCsvData(formatForFidelity(portfolio));
    };

    const downloadToDefault = (portfolio) => {
        setCsvData(formatForDefault(portfolio));
    };

    return {
        csvData,
        downloadToAdvyzon,
        downloadToFidelity,
        downloadToDefault,
    };
};
